import React, { useState } from 'react';
import './App.css';
import logo from './logo.jpeg';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';

function App() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [files, setFiles] = useState([]);
  const [error, setError] = useState('');

  const handleFileChange = (event) => {
    if (event.target.files.length > 0) {
      setSelectedFile(event.target.files[0]);
    }
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      alert("Please select a file");
      return;
    }
    setUploading(true);
    setError('');
    setFiles([]);

    const formData = new FormData();
    formData.append('file', selectedFile);

    try {
      const response = await fetch('https://brickle2.pythonanywhere.com/proccess', {
        method: 'POST',
        body: formData,
      });
      if (!response.ok) {
        throw new Error(`Upload failed: ${response.statusText}`);
      }
      const data = await response.json();
      if (data.files && Array.isArray(data.files)) {
        // Sort files by filename
        const sorted = data.files.sort((a, b) =>
          a.filename.localeCompare(b.filename)
        );
        setFiles(sorted);
      } else {
        throw new Error("Invalid response format");
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setUploading(false);
    }
  };

  const handleDownload = (filename, content) => {
    const blob = new Blob([content], { type: 'application/xhtml+xml;charset=utf-8' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const handleDownloadAll = async () => {
    if (files.length === 0) return;
    const zip = new JSZip();
    files.forEach(({ filename, content }) => {
      zip.file(filename, content);
    });

    try {
      const blob = await zip.generateAsync({ type: 'blob' });
      saveAs(blob, 'documents.zip');
    } catch (zipErr) {
      console.error('Error creating ZIP:', zipErr);
      setError('Failed to create ZIP file.');
    }
  };

  return (
    <div className="app">
      {/* HEADER */}
      <header className="app-header">
        <div className="header-content">
          <img src={logo} alt="ATR Logo" className="app-logo" />
        </div>
      </header>

      {/* HERO SECTION */}
      <section className="hero">
        <div className="hero-content">
          <h1>ATR Tables Generator</h1>
          <p>Upload your DOCX files to convert them into XHTML outputs.</p>
        </div>
      </section>

      {/* MAIN CONTENT */}
      <main className="main-content">
        <div className="upload-section">
          <h2>Upload Your Document</h2>
          <div className="file-upload-row">
            <label htmlFor="file-upload" className="btn choose-btn">Choose File</label>
            <input
              id="file-upload"
              type="file"
              onChange={handleFileChange}
              accept=".docx"
              className="file-input"
            />
            <div className="file-chosen-box">
              {selectedFile ? selectedFile.name : "No file chosen"}
            </div>

            <button
              onClick={handleUpload}
              disabled={uploading}
              className="btn primary-btn"
            >
              {uploading ? 'Uploading...' : 'Upload'}
            </button>
          </div>

          {/* Processing & Error Messages */}
          {uploading && (
            <div className="processing">
              <div className="spinner"></div>
              <p>Processing... please wait</p>
            </div>
          )}
          {error && <p className="error">Error: {error}</p>}
        </div>

        {/* DOWNLOAD SECTION */}
        {files.length > 0 && (
          <div className="download-section">
            <h2>Download Files</h2>
            <button
              onClick={handleDownloadAll}
              disabled={uploading || files.length === 0}
              className="btn download-all-btn"
            >
              Download All
            </button>
            <ul className="download-list">
              {files.map((file, index) => (
                <li key={index} className="download-list-item">
                  <span className="filename">{file.filename}</span>
                  <button
                    onClick={() => handleDownload(file.filename, file.content)}
                    className="btn download-btn"
                  >
                    Download
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}
      </main>

      {/* FOOTER */}
      <footer className="app-footer">
        <p>© {new Date().getFullYear()} ATR-Table Converter. All rights reserved. Last Updated: 31st May 2025</p>
      </footer>
    </div>
  );
}

export default App;
